//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'
import { sync } from 'vuex-pathify'
import { ContentType } from '@constants'
import routeUtils from '../utils/route'
import Content from '../components/blocks/Content.vue'
import LoginForm from '../components/auth/LoginForm.vue'
import ArticlesPage from '../components/article/ArticlesPage.vue'
import ArticleContent from '../components/article/ArticleContent.vue'
import NewsletterSubscriptions from '../components/blocks/NewsletterSubscriptions.vue'
import UserSubscriptions from '../components/blocks/UserSubscriptions.vue'
import Dossier from '../components/blocks/Dossier.vue'
import EmptyLine from '../components/blocks/EmptyLine.vue'
import Grid from '~/components/blocks/Grid.vue'
import CustomScript from '~/components/blocks/CustomScript.vue'

const PAGES = `
          query GetPage($slug: String) {
            pages(locale: "all", filters: { slug: { eqi: $slug } }, publicationState: ${process.env.STRAPI_PUBLICATION_STATE}) {
              ${routeUtils.STRAPI_QUERY}
            }
          }
        `

export default {
  components: {
    Content,
    LoginForm,
    NewsletterSubscriptions,
    ArticlesPage,
    ArticleContent,
    EmptyLine,
    Dossier,
    Grid,
    CustomScript,
    UserSubscriptions
  },
  beforeRouteLeave(to, from, next) {
    this.$store.set('app/isStrapiPage', false)

    next()
  },
  async asyncData({ params, payload }) {
    if (payload) return { page: payload }

    let slug = params.pathMatch.endsWith('/') ? `/${params.pathMatch}`.slice(0, -1) : `/${params.pathMatch}`
    const isNld = slug.startsWith('/nld')
    slug = isNld ? slug.slice(4) : slug

    const { data } = await axios.post(
      process.env.GRAPHQL_STRAPI_API,
      {
        query: PAGES,
        variables: {
          slug
        }
      },
      {
        headers: {
          Authorization: `Bearer ${process.env.STRAPI_API_TOKEN}`
        }
      }
    )

    const nldPage = data.data.pages.data.find((page) => page.attributes.locale === 'nl')
    const engPage = data.data.pages.data.find((page) => page.attributes.locale === 'en')

    if (isNld && nldPage) {
      return { page: nldPage }
    }

    if (!isNld && engPage) {
      return { page: engPage }
    }

    if (nldPage) {
      return { page: nldPage }
    }

    return { page: engPage }
  },
  data() {
    return {
      ContentType,
      loading: true
    }
  },
  head() {
    if (!this.isStrapiPage) {
      return
    }

    const social =
      this.seo?.metaSocial?.length > 0
        ? this.seo?.metaSocial.map((x) => {
            if (x.keywords === 'Facebook') {
              return [
                { property: 'og:title', content: x.title },
                { property: 'og:image', content: x.image?.data?.attributes?.url }
              ]
            }
            if (x.keywords === 'Twitter') {
              return [
                { name: 'twitter:title', content: x.title },
                { name: 'twitter:description', content: x.description },
                { name: 'twitter:image', content: x.image?.data?.attributes?.url }
              ]
            }
            return []
          })
        : []

    return {
      title: this.seo?.metaTitle ? this.seo?.metaTitle : this.title,
      meta: [
        this.seo?.metaViewport ? { name: 'viewport', content: this.seo?.metaViewport } : {},
        this.seo?.metaDescription
          ? { hid: 'description', name: 'description', content: this.seo?.metaDescription }
          : {},
        this.seo?.metaImage?.data?.attributes?.url
          ? { hid: 'og:image', property: 'og:image', content: this.seo?.metaImage?.data?.attributes?.url }
          : {},
        this.seo?.metaRobots ? { hid: 'robots', name: 'robots', content: this.seo?.metaRobots } : {},
        this.seo?.keywords ? { hid: 'keywords', name: 'keywords', content: this.seo?.keywords } : {},
        ...social.flat()
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$config.baseURL + this.$route.fullPath
        }
      ]
    }
  },
  computed: {
    filters: sync('filters'),
    currentBreakPoint() {
      return this.$store.get('app/currentBreakPoint') || 'md'
    },
    account() {
      return this.$store.get('user/user') || null
    },
    language() {
      return this.$store.get('language/locale') || 'en'
    },
    slug() {
      return this.$route.path
    },
    isStrapiPage() {
      return !!this.page
    },
    isDossierPage() {
      return this.blocks.filter((x) => x.__typename === 'ComponentBlocksDossier').length > 0
    },
    blocks() {
      return this.page ? this.page.attributes.blocks : []
    },
    seo() {
      return this.page ? this.page.attributes.seo : undefined
    },
    sideBarBlocks() {
      return this.page && this.page.attributes.sideBar ? this.page.attributes.sideBar : []
    },
    metaData() {
      return this.page && this.page.attributes.metaData ? this.page.attributes.metaData : {}
    },
    title() {
      return this.page ? this.page.attributes.title : ''
    },
    slugParts() {
      return this.$route.path.split('/').filter(Boolean)
    }
  },
  watch: {
    language(value) {
      if (!this.isStrapiPage || this.loading) {
        return
      }

      const isNld = this.slug.startsWith('/nld')

      if (!isNld && value === 'nl') {
        this.$router.replace({ path: '/nld' + this.slug })
        return
      }

      if (isNld && value === 'en') {
        this.$router.replace({ path: this.slug.slice(4) })
      }
    }
  },
  async beforeMount() {
    // setting flag to be used in other pages
    this.$store.set('app/isStrapiPage', this.isStrapiPage)

    this.loading = true
    if (this.isStrapiPage && typeof window !== 'undefined') {
      this.setBreadcrumb({})
      this.setFilters({})
    }

    if (this.seo?.structuredData) {
      const newScript = document.createElement('script')
      newScript.type = 'application/ld+json'
      newScript.innerText = JSON.stringify(this.seo.structuredData)

      document.head.appendChild(newScript)
    }

    if (!this.isStrapiPage && this.slugParts.length > 2) {
      this.loading = false
      return this.$nuxt.error({ statusCode: 404, message: 'Page Not Found' })
    }

    const isNld = this.slug.startsWith('/nld')
    if (this.isStrapiPage && isNld && this.language !== 'nl') {
      this.$store.set('language/locale', 'nl')
      this.$store.set('language/hasManuallyChanged', true)
    } else if (this.isStrapiPage && !isNld && this.language !== 'en') {
      this.$store.set('language/locale', 'en')
      this.$store.set('language/hasManuallyChanged', true)
    }

    const clientId = this.metaData.clientId
    if (!this.isStrapiPage || !clientId) {
      this.loading = false
      return
    }

    if (!this.account) {
      this.$router.replace({ path: '/client/login/' })
      return
    }

    const { data } = await this.$axios.post(`${this.$config.apiRestUrl}/client/${clientId}/VerifyUser`)
    if (!data.verified) {
      this.$router.replace({ path: '/client/login/' })
      return
    }

    this.loading = false
  },
  methods: {
    isBlockVisible(block) {
      if (!block) {
        return false
      }
      if (!block.displayRules) {
        return true
      }
      if (block.displayRules.authentication === 'Both') {
        return true
      }
      if (this.account && block.displayRules.authentication === 'Authenticated_Only') {
        return true
      }
      if (!this.account && block.displayRules.authentication === 'Unauthenticated_Only') {
        return true
      }
      return false
    },
    getContentTypeId(block) {
      const contentType = block.contentType ?? block.genericArticleContentType

      switch (contentType) {
        case 'News':
          return ContentType.NEWS
        case 'Background':
          return ContentType.BACKGROUND
        case 'Commentary':
          return ContentType.COMMENTARY
        case 'PressRelease':
          return ContentType.PRESS_RELEASE
        case 'Advertorial':
          return ContentType.ADVERTORIAL
        case 'WhitePaper':
          return ContentType.WHITE_PAPER
        case 'Profile':
          return ContentType.PROFILE
        case 'Report':
          return ContentType.REPORT
        case 'CompanyProfile':
          return ContentType.COMPANY_PROFILE
        case 'Brief':
          return ContentType.BRIEF
        case 'Chart':
          return ContentType.CHART
        default:
          return ContentType.BACKGROUND
      }
    }
  }
}
